<template>
  <div class="container">
    <BasicTitle :title="$route.name" />
    <BasicSubtitle subtitle="Los campos señalados con (*) son obligatorios." />
    <div class="container-form">
      <BasicLabel label="Número *" />
      <BorderInput
        v-model="pantry.data.number"
        label="Número *"
        @keyup.enter="onSave"
      />
      <FormError
        :show="pantry.rules.number"
        message="Ingrese un número de despensa"
      />
      <BasicLabel v-if="false" label="Prorrateo" />
      <BorderInput
        v-if="false"
        v-model="pantry.data.apportionment"
        label="Prorrateo"
        @keyup.enter="onSave"
      />
      <FormError :show="pantry.rules.apportionment" />
    </div>
    <PrimaryButton label="Guardar" :click="onSave" />
  </div>
</template>

<script>
import BasicTitle from "../../widgets/title/BasicTitle";
import BasicLabel from "../../widgets/label/BasicLabel";
import BasicSubtitle from "../../widgets/subtitle/BasicSubtitle";
import BorderInput from "../../widgets/input/BorderInput";
import BorderSelect from "../../widgets/select/BorderSelect";
import BorderInputPrefix from "../../widgets/input/BorderInputPrefix";
import BorderInputPhone from "../../widgets/input/BorderInputPhone";
import FormError from "../../widgets/error/FormError";
import PrimaryButton from "../../widgets/button/PrimaryButton";
import store from "../../store";
import { onBeforeMount, onBeforeUnmount, reactive, watchEffect } from "vue";
import { useRouter, useRoute } from "vue-router";
import { openMode, actions } from "../../constants";

export default {
  components: {
    BasicTitle,
    BasicLabel,
    BasicSubtitle,
    BorderInput,
    BorderSelect,
    BorderInputPrefix,
    BorderInputPhone,
    FormError,
    PrimaryButton,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const pantry = reactive({
      data: {
        id: "",
        buildingId: store.state.general.selectedBuilding,
        number: "",
        apportionment: "",
      },
      rules: {
        number: false,
      },
    });

    const validate = () => {
      let valid = true;

      if (!pantry.data.number) {
        pantry.rules.number = true;
        valid = false;
      }

      return valid;
    };

    const onSave = async () => {
      if (!validate()) return;

      store.commit("setLoading", true);

      const request = {
        id: pantry.data.id,
        buildingId: store.state.general.selectedBuilding,
        number: pantry.data.number,
        apportionment: pantry.data.apportionment,
      };

      let response = null;
      if (store.state.openMode === openMode.MODIFY) {
        response = await store.dispatch(actions.pantryActions.update, request);
      } else {
        response = await store.dispatch(actions.pantryActions.create, request);
      }
      store.commit("setLoading", false);
      if (response.ok) {
        store.commit("setSelectedPantries", []);
        router.push("/despensas/listado");
      } else {
        store.state.toast.add({
          severity: "error",
          summary: "",
          detail: response.message,
          life: 5000,
        });
      }
    };

    onBeforeMount(() => {
      if (!store.state.openMode) router.push("/despensas/listado");
      store.commit("addBreadcrumb", { label: route.name, to: route.path });
      if (store.state.openMode === openMode.MODIFY) {
        const selected = store.state.pantry.selectedPantries[0];
        pantry.data.id = selected.id;
        pantry.data.number = selected.number;
        pantry.data.apportionment = selected.apportionment;
      }
    });

    onBeforeUnmount(() => {
      store.commit("removeBreadcrumb");
    });

    watchEffect(() => {
      if (pantry.data.number) pantry.rules.number = false;
    });

    return { store, pantry, onSave };
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.container-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0;
}
</style>
